import { render } from "./channelDefend.vue?vue&type=template&id=0b4d0163"
import script from "./channelDefend.vue?vue&type=script&lang=js"
export * from "./channelDefend.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/channel/channelDefend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b4d0163"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b4d0163', __exports__)) {
    console.log('reload')
    api.reload('0b4d0163', __exports__)
  }
  
  module.hot.accept("./channelDefend.vue?vue&type=template&id=0b4d0163", () => {
    console.log('re-render')
    api.rerender('0b4d0163', render)
  })

}


export default __exports__